import { useNavigate } from 'react-router-dom'
import { urls } from '../../shared/urls.ts'
import { useLazyRef } from '../../shared/lib/hooks.ts'
import { RateLessonStore } from '../rateLesson/rateLessonStore.ts'
import Rive, { Fit, Layout } from '@rive-app/react-canvas'
import { motion, AnimatePresence } from 'framer-motion'
import { FormattedMessage } from 'react-intl'
import { RateLesson } from '../rateLesson/rateLesson.tsx'
import { BottomButtons, IButtonProp } from '../../shared/ui/bottomButtons.tsx'
import { useSnapshot } from 'valtio'

export const SpeakingLessonCompleted = () => {
  const navigate = useNavigate()
  const rateStore = useLazyRef(() => new RateLessonStore()).current
  const rateState = useSnapshot(rateStore.state)

  const handleSubmit = async () => {
    navigate(urls.speaking)
  }

  const firstButtonProps: IButtonProp = {
    handler: () => {
      void (async () => {
        await handleSubmit()
      })()
    },
    textId: 'Finish the lesson',
    bg: 'black-gradient',
    visible: true,
    withIcon: true,
  }

  return (
    <div className="fixed left-0 top-0 z-20 flex h-[100dvh] w-full flex-col items-center justify-between bg-blue6 backdrop-blur-20">
      <Rive
        className="pointer-events-none absolute z-40 size-full"
        src="/animations/confetti.riv"
        layout={
          new Layout({
            fit: Fit.Cover,
          })
        }
      />
      <AnimatePresence>
        {!rateState.experienceRating && (
          <motion.div
            id="lesson_start"
            className="relative h-[calc(100dvh-120px)]"
            initial={{ opacity: 0, height: 'auto' }}
            animate={{ opacity: 1, height: 'auto' }}
            exit={{ opacity: 0, height: '0' }}
            transition={{
              opacity: { duration: 0.15 },
              height: { duration: 0.3 },
            }}
          >
            <div className="mx-24 mt-40 text-center text-48 font-extrabold text-black">
              <FormattedMessage id="Lesson completed!" />
              <div className="mx-auto mt-32 flex justify-center">
                {/* Всегда показываем 3 звезды (хардкод) */}
                {[...Array(3).keys()].map((i) => {
                  return (
                    <motion.img
                      src="/images/star.png"
                      key={`star-${i}`}
                      className="size-72"
                      initial={{ opacity: 0 }}
                      animate={{ opacity: 1 }}
                      transition={{ duration: 0.3, delay: i * 0.1 }}
                    />
                  )
                })}
              </div>
              <p className="mt-24 text-14 font-bold text-gray4">
                <FormattedMessage id="finish.threeStars" />
              </p>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
      <AnimatePresence>
        <RateLesson id="lesson_exp" store={rateStore} />
      </AnimatePresence>
      <BottomButtons firstButtonProps={firstButtonProps} />
    </div>
  )
}
